import useNameReference from './useNameReference';

export default function useTranslateEnum() {
  let { nameReference } = useNameReference();
  let { nameReference: nameReferenceShort } = useNameReference(true);

  return {
    translateEnum: (srcEnum, value, useShort) => {
      let v = srcEnum.find(e => e.value === value);
      const currentNameReference = useShort ? nameReferenceShort : nameReference;
      if (v) {
        if (v.hasOwnProperty(currentNameReference)) return v[currentNameReference];
        if (value.hasOwnProperty('label')) return v.label;
      }

      return '';
    },
  };
}
